import { createSelector } from '@reduxjs/toolkit';
import { getProfile } from './getProfile';

export const getExecutorSpecializationIds = createSelector(
  getProfile,
  (profile) => profile?.executorSpecializationIds
);
